import React, { useState, useEffect } from 'react'
import { Panel, Form, Button, Table, IconButton, Icon, ButtonGroup, Row, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import SuspendProjectForm from './SuspendProjectForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  updateSuspend,
  updateCancelSuspend,
  getDownloadFileSuspended,
} from '../../redux/actions/suspendProject'
import { useParams, useHistory } from 'react-router-dom'
import SuspendFileViewWidget from './SuspendFileViewWidget'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import pathname from '../../constants/pathname'

export default function ProjectEvaluationWidget({
  schema: _schema,
  isDirector,
  attachmentSchema: _attachmentSchema,
  isCancelSuspend,
  fileList,
  ...props
}) {
  const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [attachmentSchema, setAttachmentSchema] = useState(_attachmentSchema)
  const [isFileError, setIsFileError] = useState(false)
  const [submitData, setSubmitData] = useState()
  const [approveType, setApproveType] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)

    const formData = new FormData()
    // var request
    // if(isDirector){
    //   request = {
    //     value: submitData[formSchema.note.name],
    //     IsApproved: approveType ? true : false,
    //   }

    // }else{
    if (submitData?.attachment) {
      submitData?.attachment?.forEach((element) => {
        formData.append('Files', element.blobFile || null)
      })
    } else {
      formData.append('Files', null)
    }

    formData.append('ProjectVersionId', projectId || '')
    formData.append('value', submitData[formSchema.note.name] || '')
    formData.append('IsApproved', approveType ? true : false)

    try {
      let response

      if (isCancelSuspend) {
        response = await updateCancelSuspend(projectId, formData)
      } else {
        response = await updateSuspend(projectId, formData)
      }

      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data, approve) => {
    console.log('onSubmit', data)
    setSubmitData(data)
    setApproveType(approve)
    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadFileSuspended(projectId, fileObj.id)
      console.log(file)
      var fileName = fileObj.name

      downloadFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('ดาวน์โหลด')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadFileSuspended(projectId, fileObj.id)
      console.log(file)
      var fileName = fileObj.name

      previewFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('แสดง')
    }
    doneLoading()
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {isFileError && (
        <Row style={{ marginBottom: 10 }}>
          <Message showIcon type="error" description={`${isFileError}ไม่สำเร็จ`} />
        </Row>
      )}
      {fileList && (
        <SuspendFileViewWidget data={fileList} onPreview={onPreview} onDownload={onDownload} />
      )}

      <SuspendProjectForm
        schema={formSchema}
        attachmentSchema={attachmentSchema}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
      />

      <hr />
      {isError && (
        <Message showIcon type="error" description={formSchema.buttonText + `ไม่สำเร็จ`} />
      )}

      <Button
        ripple
        // appearance="ghost"
        color="rgb(45, 168, 136)"
        appearance="primary"
        onClick={handleSubmit((e) => onSubmit(e, true))}
      >
        {formSchema.buttonText}
      </Button>

      {formSchema.buttonText2 && (
        <Button
          style={{ marginLeft: 15 }}
          ripple
          appearance="ghost"
          onClick={handleSubmit((e) => onSubmit(e, false))}
        >
          {formSchema.buttonText2}
        </Button>
      )}

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
